import { render } from "./Wechat.vue?vue&type=template&id=3f4d6d94"
const script = {}

import exportComponent from "D:\\php\\php20260824_dianshang\\mall-son_dxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__